module.exports = __webpack_public_path__ + "assets/img/recruit1.2d28aa92.png";